module.exports = __webpack_public_path__ + "static/media/close-btn-x.42cc7e7d.svg";